module.exports = __webpack_public_path__ + "img/vmap.9c604669.webp";